module.exports = __webpack_public_path__ + "statics/img/bottoms.0bcab750.png";